/*global define */
/**
 * # Summary
 * List of functions to read and manipulate URL parameters
 *
 * @module libs/plugins/jquery.urlparams
 */
define(
	'jquery.urlParams',[
		'jquery',
		'./browserFix'
	],
	function ($) {
		////////////////////////////////////////////////////////////////////////////////
		// getUrlParams
		////////////////////////////////////////////////////////////////////////////////
		var getUrlParams = $.getUrlParams;
		if (!getUrlParams) {
			//////////////////////////////////////////////////////////////////////////////////
			(function () {
				/**
				 * Function to analyse URL parameters and copy them into an Object
				 * Sample: '?site=personal&channel=corporate&amp;government'
				 * @function $.getUrlParams
				 * @param {String} urlParamString URL parameter string ( like "test=1&other=2" or "?param=val" ) or URL string that contains a "?" (e.g. http://localhost/this?param=test#hash)
				 * @return {Object} Object representation of the parameters.
				 *     {
				 *         'variable name': 'variable value'
				 *     }
				 */
				getUrlParams = function (urlParamString) {
					var ret,
						tokens,
						token,
						separatorIndex,
						paramName,
						paramVal;

					if (arguments.length === 0) { // if urlParamString is not defined
						urlParamString = window.document.location.search; // use document by default
					} else {
						urlParamString = (urlParamString + '').replace(/#.*$/, '').replace(/^[^\?#]*\?/, '?'); // cast to string and make sure to remove the initial beginning of the URL and the URL Hash
					}
					ret = {};
					if (urlParamString.length) {
						// filter the urlParamString a bit more
						if (urlParamString.charAt(0) === '?') { // if the string starts by a '?'
							urlParamString = urlParamString.substr(1);
						} else if (urlParamString.indexOf('=') === -1) { // if the string doesn't have a '?', it may be a list of url params already, just that there's at least '=' in it
							urlParamString = ''; // if not, then, there's nothing - this is an arbitrary choice
						}

						if (urlParamString.length) {
							//DEBUG
							//console.log('check urlParamString = ', urlParamString);

							tokens = urlParamString.split('&'); // split by & only. The ';' separator is in the RFC but it seems that most other browsers ignore it.
							var tokensLength = tokens.length;
							for (var i = 0; i < tokensLength; i++) {
								token = tokens[i];
								separatorIndex = token.indexOf('='); // get index of the '=' char

								// store param name
								paramName = decodeURIComponent((separatorIndex !== -1) ? token.substr(0, separatorIndex) : token);
								if (separatorIndex !== -1) { // if there's a param value
									paramVal = decodeURIComponent(token.substr(separatorIndex + 1));
								} else {
									paramVal = '';
								}
								ret[paramName] = paramVal;
							}
						}
					}

					return ret;
				}; // end of function getUrlParams(urlParamString, ignoreCache)
				$.getUrlParams = getUrlParams;
			})();
		}
		////////////////////////////////////////////////////////////////////////////////
		// setUrlParams
		////////////////////////////////////////////////////////////////////////////////
		var setUrlParams = $.setUrlParams;
		if (!setUrlParams) {
			/**
			 * Uses a params object to define or redefine parameters of a given URL, while preserving the rest of the URL components
			 * Make sure to preserve the original parameter order when redefining existing parameters
			 * @function $.setUrlParams
			 * @param {object} params
			 * @param {string} url
			 * @param {boolean} [_unsetFlag] It is true to remove the params from url_str; default value is false if it is not passed in;
			 * @return {string} new modified URL
			 */
			setUrlParams = function (params, url, _unsetFlag) {
				var ret = url;

				if (params instanceof Object) {
					url = url || '';
					var urlHash = '',
						urlRoot = url,
						param_arr_actual = {},
						splitStr = url.match(/^([^#]*)(#.*)$/),
						queryString;

					if (splitStr) { // if there's a URL hash
						url = splitStr[1]; // example: "//abc.com?a=4"
						urlRoot = url;
						urlHash = splitStr[2]; // add the rest of the hash. This can handle cases where there are multiple '#' characters
					}

					if (url.indexOf("?") >= 0) { // if there are existing URL parameters
						splitStr = url.match(/^([^\?]*)(\?.*)$/);
						urlRoot = splitStr[1];
						param_arr_actual = getUrlParams(splitStr[2]);

						//DEBUG
						//console.log('setUrlParams: analyse ', splitStr[2], ' and found \n', param_arr_actual);
					}

					// Set URL param
					/* debug
					 $.each(param_arr_actual, function(key, value){
					 console.log('aaa key = ', key);
					 console.log('aaa value = ', value);
					 })
					 */

					if (_unsetFlag) {
						// Unset URL param
						$.each(params, function (key, value) {
							delete param_arr_actual[key];
						});
					} else {
						// Set URL param
						$.extend(param_arr_actual, params);
					}

					queryString = $.param(param_arr_actual, true); // transform an object into a url param string

					if (queryString) { // add '?' if the URL params string is non-empty
						queryString = '?' + queryString;
					}

					//DEBUG
					// console.log('urlRoot', urlRoot);
					// console.log('str', str);
					// console.log('urlHash', urlHash);
					ret = urlRoot + queryString + urlHash;
				}
				return ret;
			}; // end of window.setUrlParams = function(params, url_str, _unsetFlag)
			$.setUrlParams = setUrlParams;
		}
		////////////////////////////////////////////////////////////////////////////////
		var unsetUrlParams = $.unsetUrlParams;
		if (!unsetUrlParams) {
			/**
			 * Uses a params object to remove parameters of a given URL
			 * It removes params from url_str
			 * @todo Write more doc
			 * @function $.unsetUrlParams
			 * @param {object} paramsToUnset
			 * @param {string} url
			 * @return {string} new modified URL by calling setUrlParams() with passing _unsetFlag as true
			 */
			unsetUrlParams = function (paramsToUnset, url) {
				return setUrlParams(paramsToUnset, url, true);
			};
			$.unsetUrlParams = unsetUrlParams;
		}
	}
);


